import injectionCode from '../../../../preview/advanced-checkout'

const type = 'advanced'
const path = 'server/html/views'
const name = 'checkout.ejs'
const fullPath = `${path}/${name}`

const conditions = [
  {
    parameter: 'buttons',
    type: 'includes',
    value: 'payment-buttons_3ds',
  },
]

export { type, path, name, fullPath, conditions, injectionCode }
